import { ImageIcon, LayersIcon, XIcon } from '@air/design-icons';
import { RadioGroup, RadioGroupItem, type RadioGroupProps } from '@air/primitive-radio-group';

export enum DuplicateItemChoice {
  Stack = 'stack',
  Separate = 'separate',
  Cancel = 'cancel',
}

export type DuplicateItemOptionsProps = Pick<RadioGroupProps, 'name' | 'onValueChange' | 'value'> & {
  isApplyAll?: boolean;
};

export const DuplicateItemOptions = ({ isApplyAll, name, onValueChange, value }: DuplicateItemOptionsProps) => {
  return (
    <RadioGroup data-testid="DUPLICATE_ITEMS_OPTIONS" name={name} onValueChange={onValueChange} value={value}>
      <RadioGroupItem
        className="rounded-4 border ads:border-ads-gray-5 border-gray-5 p-3"
        data-testid="DUPLICATE_ITEMS_OPTIONS_OPTION"
        data-id={DuplicateItemChoice.Stack}
        id={`${name}-${DuplicateItemChoice.Stack}`}
        value="stack"
      >
        <LayersIcon className="ads:text-icon-subtle text-gray-8" size="sm" />
        Stack as new version
      </RadioGroupItem>

      <RadioGroupItem
        className="rounded-4 border ads:border-ads-gray-5 border-gray-5 p-3"
        data-testid="DUPLICATE_ITEMS_OPTIONS_OPTION"
        data-id={DuplicateItemChoice.Separate}
        id={`${name}-${DuplicateItemChoice.Separate}}`}
        value="separate"
      >
        <ImageIcon className="ads:text-icon-subtle text-gray-8" size="sm" />
        Upload as separate {isApplyAll ? 'items' : 'item'}
      </RadioGroupItem>

      <RadioGroupItem
        className="rounded-4 border ads:border-ads-gray-5 border-gray-5 p-3"
        data-testid="DUPLICATE_ITEMS_OPTIONS_OPTION"
        data-id={DuplicateItemChoice.Cancel}
        id={`${name}-${DuplicateItemChoice.Cancel}`}
        value="cancel"
      >
        <XIcon className="ads:text-icon-subtle text-gray-8" size="sm" />
        Cancel upload for&nbsp;
        {isApplyAll ? 'all items' : 'this item'}
      </RadioGroupItem>
    </RadioGroup>
  );
};
